import { ILookup } from '../common/interfaces/ILookup.interface';
import { ListBoxItem } from '../cpq-list-box/ListBoxItem';

export class FormulaBuilderExpression extends ILookup<number, string> {
    public expression: string;
    public canContainAttribute: boolean;
}

export class FormulaPlaceHolders {
    public static readonly attributePlaceholder = '@attribute@';
    public static readonly attributeValuePlaceholder = '@attribute_value@';
    public static readonly actionAttributeNamePlaceholder = '@actionName@';
    public static readonly actionAttributeNameValuePlaceholder = '@actionNameValue@';
    public static readonly actionAttributeSeparatorPlaceholder = '@actionName|Separator@';
    public static readonly sequencePlaceholder = '@sequence@';
    public static readonly parameterPlaceholder = '@parameter@';
}

export class Variable extends ILookup<number, string> {
    public tag: string;
}

export class AttributeValue extends ILookup<number, string> {
    public value: string;
}

export class ActionAttribute extends ILookup<number, string> {
    public name: string;
    public value: string;
}

export class Sequence extends ILookup<number, string> { }

export class FormulaBuilderLookup {
    public variables: Array<FormulaBuilderExpression>;
    public operations: Array<FormulaBuilderExpression>;
    public sequenceOperators: Array<FormulaBuilderExpression>;
    public attributes: Array<ILookup<number, string>>;
    public attributeValues: Array<AttributeValue>;
    public actionAttributeValues: Array<ActionAttribute>;
    public cartTagParameters: Array<string>;
    public sequences: Array<Sequence>;
    public actions: Array<FormulaBuilderExpression>;
    public cartActions: Array<FormulaBuilderExpression>;
    public actionAttributes: Array<ListBoxItem>;
    public actionParameters: Array<ILookup<number, string>>;
    
    constructor() {
        this.variables = new Array<FormulaBuilderExpression>();
        this.operations = new Array<FormulaBuilderExpression>();
        this.sequenceOperators = new Array<FormulaBuilderExpression>();
        this.attributes = new Array<ILookup<number, string>>();
        this.attributeValues = new Array<AttributeValue>();
        this.actionAttributeValues = new Array<ActionAttribute>();
        this.cartTagParameters = new Array<string>();
        this.sequences = new Array<Sequence>();
        this.actions = new Array<FormulaBuilderExpression>();
        this.cartActions = new Array<FormulaBuilderExpression>();
        this.actionAttributes = new Array<ListBoxItem>();
        this.actionParameters = new Array<ILookup<number, string>>();
    }
}

export class Formula {
    public selectedVariable: number;
    public selectedOperation: number;
    public selectedSequenceOperator: number;
    public selectedAttribute: number;
    public selectedAttributeValue: number;
    public selectedSequence: number;
    public selectedAction: number;
    public selectedCartAction: number;
    public selectedActionAttributes: Array<number>;
    public conditionFormula: string;
    public selectedCartActionParameter: number;

    constructor() {
        this.selectedActionAttributes = new Array<number>();
    }
}

export class SyntaxCheck {
    public productId: number;
    public formula: string;
}

export class SyntaxCheckResponse {
    public status: string;
    public message: string;
}
export class SyntaxVisualizeResponse {
    public value: string;
    public name: string;
    public trueBranch?: SyntaxVisualizeResponse;
    public falseBranch?: SyntaxVisualizeResponse;
    public condition?: SyntaxVisualizeResponse;
    public first?: SyntaxVisualizeResponse;
    public second?: SyntaxVisualizeResponse;
    public kind?: number;
    public pos?: number;
    public children: Array<SyntaxVisualizeResponse>;
}
export class FormulaBuilderConfig {
    public formulaBuilderType: FormulaBuilderType;
    public ftype: number;
    public isTrigger: boolean;
    public isTableTag: boolean;
    public formula?: string;
    public productId?: number;
    public containerId?: number;
    public hideLabel: boolean;

    constructor(formulaBuilderType: FormulaBuilderType,
        formula?: string,
        isTrigger?: boolean,
        ftype?: number,
        productId?: number,
        containerId?: number) {
        this.formulaBuilderType = formulaBuilderType;
        this.formula = formula;
        this.ftype = ftype ? ftype : 3;
        this.isTrigger = isTrigger;
        this.productId = productId ? productId : 0;
        this.containerId = containerId ? containerId : 0;
    }
}

export enum FormulaBuilderType {
    Product = 1,
    Cart
}

export enum FormulaBuilderVisualizeStrings {
    Condition = "Condition",
    IfTrue = "If True",
    IfFalse = "If False",
    TestedValue = "Tested Value",
    TestValue = "Test Value",
    Pattern = "Pattern",
    String = "String",
    Option = "Option",
    MinValue = "Min Value",
    MaxValue = "Max Value"
}